import {
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  ElementRef,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener,
  input,
  Input,
  signal,
} from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { Transaction } from '../../Interfaces/interfaces';
import { CommonModule } from '@angular/common';
import { ApiCallService } from '../../Services/api-call-service.service';
import { LoaderService } from '../../Services/loader-service.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ToastrService } from 'ngx-toastr';
import { GameService } from '../../Services/game.service';
import { UtilsService } from '../../Services/utils.service';
import { LocalTimePipe } from '../../Pipes/local-time.pipe';
import { loadStripe, Stripe, StripeElements, StripeCardElement } from '@stripe/stripe-js';
import {
  faCheck,
  faCircleInfo,
  faEye,
  faEyeSlash,
  faSackDollar,
  faSurprise,
} from '@fortawesome/free-solid-svg-icons';
import { ErrorhandlingService } from '../../Services/error-handling.service';
import { paymentTypes } from '../../constants/PaymentTypes';
import { debug } from 'console';
import { KycPopupComponent } from '../kyc-popup/kyc-popup.component';
import { Router } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

declare var Square: any;

@Component({
  selector: 'app-add-wallet',
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    KycPopupComponent,
    NgxSkeletonLoaderModule,
  ],
  templateUrl: './add-wallet.component.html',
  styleUrl: './add-wallet.component.scss',
})
export class AddWalletComponent implements OnInit, AfterViewInit, OnChanges {

  stripe: Stripe | null = null;
  elements: StripeElements | null = null;
  infoIcon = faCircleInfo;
  surpriseIcon = faSurprise;
  sackDollarIcon = faSackDollar;
  faCheck = faCheck;

  showDateFilter: boolean = false;
  startDate: string | null = null;
  endDate: string | null = null;
  paymentForm: FormGroup;
  paymentFormSquare: FormGroup;
  cashappForm: FormGroup;
  squareForm: FormGroup;
  squarecashForm: FormGroup;
  showKycPopup: boolean = false;
  public minDeposit: number = 0;
  public maxDeposit: number = 0;
  private payments: any;
  private cashAppPay: any;
  email: any
  constructor(
    private apiCallService: ApiCallService,
    private loaderService: LoaderService,
    private toastr: ToastrService,
    private handleError: ErrorhandlingService,
    private GameService: GameService,
    private utilsService: UtilsService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private _errorHandleService: ErrorhandlingService,
    private router: Router
  ) {
    this.paymentForm = this.fb.group({
      cardNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{13,16}$/), // Basic pattern for 13-16 digits
        ],
      ],
      month: [
        '',
        [
          Validators.required,
          Validators.min(1),
          Validators.max(12),
          Validators.pattern(/^\d{1,2}$/),
        ],
      ],
      year: [
        '',
        [
          Validators.required,
          Validators.min(new Date().getFullYear()), // Min year is current year
          Validators.max(2099),
          Validators.pattern(/^\d{4}$/), // Enforce 4-digit year
        ],
      ],
      cvv: ['', [Validators.required, Validators.pattern(/^\d{3,4}$/)]],
      amount: [
        '',
        [
          // Amount is now dynamic with a default value
          Validators.required,
          Validators.min(1),
        ],
      ],
    });
    this.paymentFormSquare = this.fb.group({
      amount: ['', [Validators.required, Validators.min(1)]],
      fullName: ['', Validators.required],
      streetAddress: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      country: ['United States', Validators.required]
    });
    this.cashappForm = this.fb.group({
      amount: ['', [Validators.required, Validators.min(1)]],
    });

    this.squareForm = this.fb.group({
      amount: ['', [Validators.required, Validators.min(1)]],
      email: ['', [Validators.required, Validators.email]],
      addressLine1: ['', Validators.required],
      addressLine2: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required],
      postalCode: ['', Validators.required],
      country: ['', Validators.required],
      billerName: ['', Validators.required],
    });
    this.squarecashForm = this.fb.group({
      amount: ['', [Validators.required, Validators.min(1)]],
    });
  }

  private destroy$ = new Subject<void>();
  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  closeKycPopup() {
    this.showKycPopup = false;
    // this.loaderService?.triggerWalletFunction();
    // this.router.navigate(['dashboard/wallet']);

    if (this.popupRedirect) {
      this.cdr.markForCheck();
      this.cdr.detectChanges();
      setTimeout(() => {
        this.router.navigate([this.popupRedirect]);
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    try {
      if (this.cashAppPay && typeof this.cashAppPay.destroy === 'function')
        this.cashAppPay.destroy();
    } catch (e) {
      /* ignore */
    }
  }
  @ViewChild('transactionTable', { static: false })
  transactionTable!: ElementRef;

  currentSearchTerm: string = '';

  onScroll(): void {
    const element = this.transactionTable.nativeElement;
    if (element.offsetHeight + element.scrollTop + 1 >= element.scrollHeight) {
      this.currentPage++;

      this.getWalletBalance(this.currentPage, this.currentSearchTerm);
    }
  }

  onMobileScroll(event: any) {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.currentPage++;

      this.getWalletBalance(this.currentPage, this.currentSearchTerm);
    }
  }

  onScrollTop(): void { }

  onScrollBottom(): void { }

  dropdownOpen = false;
  selectedFilter = 'All Redeem';

  selectFilter(filter: string, event: Event) {
    event.preventDefault();
    this.selectedFilter = filter;
    this.dropdownOpen = false;

    console.log('Filter selected:', filter);
  }

  public totalBalance = 0;

  get privateValue(): number {
    return this.totalBalance;
  }
  transactions: any[] = [];
  Debittransactions: any[] = [];
  selectedTab: string = 'credit';
  searchControl: string = '';
  @Input() showModal = false;
  showwithdrawModal = false;
  newBalance = 0;
  amountDropdownOpen = false;

  selectAmount(amount: number): void {
    this.newBalance = amount;
    this.amountDropdownOpen = false;

    if (this.selectedAccountType === 'CashApp2') {
      this.cashAppPayInitialized = false;
      try {
        if (this.cashAppPay && typeof this.cashAppPay.destroy === 'function') {
          this.cashAppPay.destroy();
        }
      } catch (e) {
        /* ignore */
      }
    }
  }

  showicon = faEye;
  hideicon = faEyeSlash;

  toggleData(bar: string) {
    this.selectedTab = bar;
  }

  WalletPayload() {
    return {
      customerId: Number(localStorage.getItem('customerId')),
      pageNumber: this.currentPage,
      pageSize: 10,
      searchText: this.currentSearchTerm || '',
      startDate: this.startDate || '',
      endDate: this.endDate || '',
    };
  }
  // Button-level loading state for the "Pay Securely"/"Add" submit
  // buttons — replaces the full-screen loaderService spinner for these
  // payment-submission actions specifically.
  isProcessingPayment = false;
  // Skeleton placeholder state for the "Choose Account" payment-method
  // grid while it loads — replaces the full-screen loaderService spinner
  // that used to fire the moment the Add Balance modal opened.
  isLoadingPaymentMethods = false;
  readonly paymentMethodSkeletonTiles = Array.from({ length: 6 });

  getWalletBalance(pageNumber: number = 1, searchText: string = '') {
    this.loaderService.show();
    const CustomerID = localStorage.getItem('customerId');
    // let payload = `Wallet/GetWalletBalance?CustomerId=${CustomerID}&PageNumber=${pageNumber}&PageSize=${10}`;
    let payload = this.WalletPayload();

    // if (searchText.trim()) {
    //   payload += `&SearchText=${encodeURIComponent(searchText.trim())}`;
    // }

    this.apiCallService
      .PostCallWithToken(payload, 'Wallet/GetWalletBalance')
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          if (response && response.responseCode == 200) {
            this.loaderService?.triggerWalletFunction();
            this.updateBalance(response.data.totalBalance);
            this.totalBalance =
              response.data.totalBalance === ''
                ? this.totalBalance
                : parseFloat(response.data.totalBalance);

            const creditTransactions = response.data.creditWallets.map(
              (transaction: any) => ({
                ...transaction,
                type: 'credit',
                balance: transaction.creditBalance,
                time: transaction.creditTime,
              })
            );

            const debitTransactions = response.data.debitWallets.map(
              (transaction: any) => ({
                ...transaction,
                type: 'debit',
                balance: transaction.debitAmount,
                time: transaction.debitDate,
              })
            );

            const newTransactions = [
              ...creditTransactions,
              ...debitTransactions,
            ].sort(
              (a, b) => new Date(b.time).getTime() - new Date(a.time).getTime()
            );

            if (pageNumber === 1) {
              this.transactions = newTransactions;
            } else {
              this.transactions = [...this.transactions, ...newTransactions];
            }

            this.loaderService.hide();
          } else {
            this.handleError.handleResponseError(response);
          }
        },
        (error) => {
          this.handleError.handleHttpError(error);
        }
      );
  }

  updateBalance(newBalance: number): void {
    this.GameService.balance = newBalance;
  }

  get filteredTransactions() {
    let allTransactions = this.transactions;

    switch (this.selectedFilter) {
      case 'Credited':
        allTransactions = allTransactions.filter(
          (transaction) => transaction.type === 'credit'
        );
        break;
      case 'Debited':
        allTransactions = allTransactions.filter(
          (transaction) => transaction.type === 'debit'
        );
        break;
      case 'All Redeem':
      default:
        break;
    }

    return allTransactions;
  }

  performSearch() {
    this.currentSearchTerm = this.searchControl;
    this.currentPage = 1; //
    this.getWalletBalance(1, this.currentSearchTerm);
  }

  onSearchInputChange(event: any) {
    if (event.key !== 'Enter') {
      if (!this.searchControl || this.searchControl.trim() === '') {
        this.clearSearch();
      }
    }
  }
  removeLeadingZero(event: any) {
    this.utilsService.removeLeadingZero(event);
  }

  clearSearch() {
    this.searchControl = '';
    this.currentSearchTerm = '';
    this.currentPage = 1;
    this.getWalletBalance(1, '');
  }
  card: any;
  cardSourceId: any;

  async ngOnInit() {
    // this.openAddBalanceModal();
    this.GetSquareAvilableAccount('Card');

    this.getActivePaymentMethods();
    this.loadDynamicPaymentAmounts();

    // const payments = Square.payments(this?.SquareApiToken, this?.SquareProductId);
    // this.card = await payments.card();
    // await this.card.attach('#card-container');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showModal'] && this.showModal) {
      this.getDisputeNotification();
    }
  }

  // Hides GooglePay / ApplePay payment methods when the customer has an
  // active dispute (ShowDisputePopup === true).
  showDisputePopup: boolean = false;
  getDisputeNotification() {
    const customerId = localStorage.getItem('customerId');
    this.apiCallService
      .GetCallWithToken(`Customer/GetDisputeNotification?CustomerId=${customerId}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            this.showDisputePopup =
              response.data?.showDisputePopup === true ||
              response.data?.showDisputePopup === 1;
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
        },
      });
  }
  // Square integration Start
  async initializeSquareCard() {
    if (!this.SquareApiToken || !this.SquareProductId) {
      console.error('Square keys missing');
      return;
    }

    const payments = Square.payments(this.SquareApiToken, this.SquareProductId);

    this.card = await payments.card();
    await this.card.attach('#card-container');
  }

  async handlePaymentSquare() {
    // 1. Extract the amount from the form
    const amount = this.paymentFormSquare.get('amount')?.value;
    // 2. Basic check: Ensure the form is valid and amount is provided
    if (this.paymentFormSquare.invalid) {
      this.toastr.error('Please Fill All Fields', 'Form Error');
      return;
    }

    // 1. Locate the CashApp record from your data array
    const cardInfo = this.AccountType.find((account: any) => account.name === 'Card');
    if (cardInfo) {
      const min = cardInfo.MinDepositLimit;
      const max = cardInfo.MaxDepositLimit;
      // 2. Validate Minimum Limit
      if (amount < min) {
        this.loaderService.hide();
        this.toastr.warning(`Error: Min Deposit for Card is ${min}`, 'Invalid Amount');
        return
      }
      // 3. Validate Maximum Limit (only if MaxDepositLimit is greater than 0)
      if (max > 0 && amount > max) {
        this.loaderService.hide();
        this.toastr.warning(`Error: Max Deposit for Card is ${max}`, 'Invalid Amount');
        return
      }
    }

    this.loaderService.show();
    const result = await this.card.tokenize();
    if (result.status === 'OK') {
      //  console.log('Token created:', result.token);
      // this.cardSourceId = result.token;
      // Send result.token to your .NET Backend
      // this.sendTokenToBackend(result.token);
      this.loaderService.hide();
      this.PostSquarePayment(result.token);
    }
    else {
      this.loaderService.hide()
        ;
    }
  }
  PostSquarePayment(token: string) {
    // this.squareForm.markAllAsTouched();
    // if (this.squareForm.invalid) {
    //   this.loaderService.hide();
    //   return;
    // }
    this.loaderService.show();
    const formValue = this.paymentFormSquare.value;
    // const payload = {
    //   customerId: Number(localStorage.getItem('customerId')),
    //   amount: this.squareForm.value.amount,
    //   accountId: this.SquareAvailableAccounts?.Id,
    //   source: 'square,card',
    //   cardSourceId: token,
    // };
    const payload = {
      customerId: Number(localStorage.getItem('customerId')),
      amount: Number(formValue.amount),
      source: 'square,card',
      accountId: this.SquareAvailableAccounts?.Id,
      cardSourceId: token,
      email: localStorage.getItem('email') || '',
      addressLine1: formValue.streetAddress,
      city: formValue.city,
      zip: formValue.zip,
      state: formValue.state,
      promocode: this.appliedPromoCode || ''
    };

    this.apiCallService
      .PostCallWithToken(payload, 'SquarePayment/CreateSquarePayment')
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            this.toastr.success(response.responseMessage, 'Success');
            this.squareForm.reset();
            this.loaderService?.triggerWalletFunction();
            this.loaderService.hide();
            this.hideWalletModal();
          } else {
            this.handleError.handleResponseError(response);
            this.loaderService.hide();
            this.hideWalletModal();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.loaderService.hide();
          this.hideWalletModal();
        },
      });
  }

  // Get Square account

  SquareAvailableAccounts: any;
  SquareApiToken: any = '';
  SquareProductId: any = '';

  GetSquareAvilableAccount(Accountname: string) {
    if (Accountname != 'Card') {
      return;
    }
    this.apiCallService
      .GetCallWithToken('SquarePayment/GetSquareAvilableAccount')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (response) => {
          if (response && response.responseCode === 200) {
            this.SquareAvailableAccounts = response.data[0];
            this.SquareApiToken = this.SquareAvailableAccounts?.ApiToken;
            this.SquareProductId = this.SquareAvailableAccounts?.ProductId;

            // console.log('Square Accounts:', response.data);

            await this.initializeSquareCard();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
        },
      });
  }

  // Add this near the top of the class
  cashAppPayInitialized = false;
  // ...existing code...
  async initializeCashAppPay(amount: number, containerId: string = 'cash-app-pay-container') {
    this.loaderService.show();
    if (!this.SquareAvailableAccounts) {
      console.error('SquareAvailableAccounts not loaded');
      this.toastr.error('Configuration missing', 'Error');
      this.loaderService.hide();
      return;
    }

    // derive client-side values (inspect your backend response for exact field names)
    const applicationId =
      this.SquareAvailableAccounts?.ApplicationId ||
      this.SquareAvailableAccounts?.AppId ||
      this.SquareAvailableAccounts?.ClientApplicationId ||
      this.SquareApiToken; // fallback for debugging only (DO NOT use server secret in production)

    const locationId =
      this.SquareAvailableAccounts?.LocationId ||
      this.SquareAvailableAccounts?.ProductId ||
      this.SquareProductId;

    // console.log('Square init values:', { applicationId, locationId, envScriptLoaded: !!(window as any).Square });

    if (!applicationId || !locationId) {
      this.toastr.error(
        'Missing Application ID or Location ID for Square',
        'Configuration'
      );
      this.loaderService.hide();
      return;
    }

    try {
      // make sure SDK loaded
      if (!(window as any).Square) {
        throw new Error(
          'Square.js library not loaded. Use sandbox or production script in index.html'
        );
      }

      // use public applicationId and locationId
      this.payments = (window as any).Square.payments(
        applicationId,
        locationId
      );

      if (!this.payments) throw new Error('Square.payments() returned falsy');

      const paymentRequest = this.payments.paymentRequest({
        countryCode: 'US',
        currencyCode: 'USD',
        total: {
          amount: (amount && amount > 0 ? amount : 5).toFixed(2),
          label: 'Total',
        },
      });

      // destroy previous instance if exists
      try {
        if (this.cashAppPay && typeof this.cashAppPay.destroy === 'function')
          this.cashAppPay.destroy();
      } catch (e) {
        /* ignore */
      }

      this.cashAppPay = await this.payments.cashAppPay(paymentRequest, {
        redirectURL: window.location.href,
        referenceId: `wallet-${Date.now()}`,
      });

      const container = document.getElementById(containerId);
      if (!container) throw new Error(`${containerId} not found`);
      this.loaderService.hide();
      await this.cashAppPay.attach(`#${containerId}`);
      this.cashAppPayInitialized = true;

      // Use addEventListener instead of .on()
      this.cashAppPay.addEventListener('ontokenization', (event: any) => {
        // Note: event.detail is where Square stores the result
        const tokenResult = event.detail.tokenResult;

        if (tokenResult.status === 'OK') {
          const token = tokenResult.token;
          // console.log('Cash App tokenization successful, token:', token);
          // this.handleCashAppToken(token); // Send to your .NET backend
          this.PostSquareCashAppPayment(token);
        } else {
          console.error('Cash App tokenization failed:', tokenResult.errors);
          this.toastr.error('Tokenization failed', 'Payment Error');
        }
      });
    } catch (err: any) {
      console.error(
        'Initializing Cash App Pay failed:',
        err,
        err?.errors || err?.detail
      );
      this.toastr.error(
        err?.message || 'Failed to initialize Cash App Pay',
        'Error'
      );
      this.loaderService.hide();
    }
  }
  // ...existing code...
  PostSquareCashAppPayment(token: string) {
    this.squarecashForm.markAllAsTouched();
    if (this.squarecashForm.invalid) {
      this.loaderService.hide();
      return;
    }
    this.loaderService.show();
    const payload = {
      customerId: Number(localStorage.getItem('customerId')),
      amount: this.squarecashForm.value.amount,
      accountId: this.SquareAvailableAccounts?.Id,
      source: 'square,cashapp',
      cardSourceId: token,
      promocode: this.appliedPromoCode || ''
    };
    this.apiCallService
      .PostCallWithToken(payload, 'SquarePayment/CreateSquarePayment')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            this.toastr.success(response.responseMessage, 'Success');
            this.squarecashForm.reset();
            this.loaderService?.triggerWalletFunction();
            this.loaderService.hide();
            this.hideWalletModal();
          } else {
            this.handleError.handleResponseError(response);
            this.loaderService.hide();
            this.hideWalletModal();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.loaderService.hide();
          this.hideWalletModal();
        },
      });
  }
  // Square integration end
  openAddBalanceModal() {
    this.showModal = true;
    this.getDisputeNotification();
    this.showcard = true;
    this.paymentForm.reset();
     this.paymentFormSquare.reset();
    this.showcashApp = false;
    this.showChimeZelle = false;
    this.cashappForm.reset();
    this.getAccountsDropdown();
    this.newBalance = 0;
    this.promoCode = '';
    this.appliedPromoCode = '';
    this.promoError = '';
    this.selectedAccount = 'Manual';
    this.selectedAccounttitle = '';
    this.selectedAccountType = 'Card';
  }

  getCustomerID(): number | null {
    return Number(localStorage.getItem('customerId'));
  }
  getToken(): string | null {
    return localStorage.getItem('token');
  }
  getUsername(): string | null {
    return localStorage.getItem('userName');
  }
  addBalance() {
    if (this.newBalance > 0 && this.newBalance >= 5 && this.newBalance <= 300) {
      if (this.isShowManualEntry) {
        this.addWalletRequest();
      } else {
        this.isProcessingPayment = true;

        const apiurl = `Wallet/CreateCoralPayment?Payment=${this.newBalance
          }&Username=${this.getUsername()}`;

        // Open a new blank tab immediately to prevent browser pop-up blockers
        const newTab = window.open('', '_blank');

        this.apiCallService.GetCallWithToken(apiurl).pipe(takeUntil(this.destroy$)).subscribe({
          next: (response) => {
            if (response && response.responseCode === 200) {
              this.toastr.success(response.responseMessage, 'Success');
              if (newTab) {
                newTab.location.href = response.data.purchaseURL; // Redirect the blank tab
              } else {
                window.open(response.data.purchaseURL, '_blank'); // Fallback in case tab is blocked
              }
            } else {
              this.handleError.handleResponseError(response);
              if (newTab) newTab.close(); // Close the tab if API fails
            }
            this.isProcessingPayment = false;
            this.hideWalletModal();
          },
          error: (error) => {
            this.handleError.handleHttpError(error);
            if (newTab) newTab.close(); // Close the tab on error
            this.isProcessingPayment = false;
            this.hideWalletModal();
          },
        });
      }
    } else {
      this.toastr.info('Amount must be within 5 to 300', 'Invalid Amount');
    }
  }
  showBalance: boolean = false;

  addWalletRequestPayload() {
    return {
      customerId: this.getCustomerID(),
      balance: this.newBalance || 0,
      type: 'Credit',
      status: 'Pending',
      source: this.selectedAccount || '',
      accountTitle: this.selectedAccounttitle || '',
      imageUrl: this.uploadProfileImage || '',
      accountInfo: this.CustomerTag || '',
      email: this.email,
      promocode: this.appliedPromoCode || ''
    };
  }
  addWalletRequest() {
    const payload = this.addWalletRequestPayload();
    if (
      payload.imageUrl != '' &&
      payload.source != '' &&
      payload.accountTitle != '' &&
      payload.email != ''
    ) {
      this.isProcessingPayment = true;
      this.apiCallService
        .PostCallWithToken(payload, 'Wallet/CreateWalletPaymentRequest')
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            if (response && response.responseCode === 200) {
              this.toastr.success(response.responseMessage, 'Success');
              this.loaderService?.triggerWalletFunction();
              this.isProcessingPayment = false;
              this.hideWalletModal();
            } else {
              this.handleError.handleResponseError(response);
              // this.loaderService.hide();
              this.hideWalletModal();
            }
          },
          error: (error) => {
            this.handleError.handleHttpError(error);
            // this.loaderService.hide();
            this.hideWalletModal();
          },
        });
    } else {
      this.toastr.info(
        'Please Select Account Details Add email  and Upload image',
        'Validation'
      );
    }
  }

  // filter section

  currentPage: number = 1;

  // TS Code for Pagination End
  isAccountSelected: boolean = false;
  isShowManualEntry: boolean = true;
  onAccountChange(selectedValue: any): void {
    this.selectedAccounttitle = '';
    this.isAccountSelected = true;
  }
  onAccountTypesChange(selectedValue: string): void {
    this.selectedAccountType = selectedValue;
  }

  accountDropdownOpen = false;
  selectedAccount: string = '';
  selectAccount(account: any, event: Event) {
    event.preventDefault();
    this.selectedAccount = account?.name || '';
    this.accountDropdownOpen = false;
    this.onAccountChange(account || '');
  }
  selectAccountTypes(name: string, event: Event) {
    event.preventDefault();
    this.selectedAccountType = name;
    if (name == 'Manual') {
      this.accountDropdownOpen = true;
    }
    // this.onAccountChange(name);
  }

  @HostListener('document:click')
  closeDropdown() {
    this.accountDropdownOpen = false;
  }

  toggleManualEntry() {
    this.isShowManualEntry = !this.isShowManualEntry;
  }
  manualEntry(event: Event) {
    event.stopPropagation();
    this.isShowManualEntry = true;
    this.selectedAccountType = '';
    this.selectedAccounttitle = '';
    this.uploadProfileImage = '';
  }

  autoEntry(event: Event) {
    event.stopPropagation();
    this.isShowManualEntry = false;
  }

  selectedAccountType: string = '';
  selectedAccounttitle: string = '';
  PaypalAccounts: any;
  ChimeAccounts: any;
  ZelleAccounts: any;
  // api/

  manualAccounts: any = [];
  getAccountsDropdown() {
    this.apiCallService
      .GetCallWithToken('CashTag/GetAccountsDropdown')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            // this.ChimeAccounts = response.data.chime;
            // this.CashtagAccounts = response.data.cashApp;
            this.manualAccounts = Object.keys(response.data).map((key) => ({
              name: key,
              accounts: response.data[key],
            }));
            this.ChimeAccounts =
              response.data.chime.length > 0
                ? response.data.chime
                : [{ accountDetail: 'No data found' }];
            this.PaypalAccounts =
              response.data.cashApp.length > 0
                ? response.data.payalApp
                : [{ accountDetail: 'No data found' }];
            this.ZelleAccounts =
              response.data.zelle.length > 0
                ? response.data.zelle
                : [{ accountDetail: 'No data found' }];
          } else {
            // this.handleError.handleResponseError(response);
            // this.hideWalletModal();

            this.ChimeAccounts = [{ accountDetail: 'No data found' }];
            this.PaypalAccounts = [{ accountDetail: 'No data found' }];
            this.ZelleAccounts = [{ accountDetail: 'No data found' }];
          }
        },
        error: (error) => {
          // this.handleError.handleHttpError(error);
          // this.hideWalletModal();
        },
      });
  }

  AccountType: any = [
    // {
    //   id: 3,
    //   name: 'Card',
    //   bg_image: '/cmax2-assets/payments/master.png',
    // },
    // {
    //   id: 1,
    //   name: 'CashApp',
    //   bg_image: '/cmax2-assets/payments/cashapp.png',
    // },
    // {
    //   id: 2,
    //   name: 'Chime',
    //   bg_image: '/cmax2-assets/payments/chime.png',
    // },
    // {
    //   id: 3,
    //   name: 'Zelle',
    //   bg_image: '/cmax2-assets/payments/zelle.png',
    // },
    // {
    //   id: 3,
    //   name: 'Paypal',
    //   bg_image: '/cmax2-assets/payments/paypal.svg',
    // },
  ];

  // getActivePaymentMethods() {
  //   this.loaderService.show();
  //   this.apiCallService
  //     .GetCallWithToken('PaymentMethod/GetAllActivePaymentMethods')
  //     .subscribe(
  //       (res) => {
  //         if (res && res.responseCode == 200) {
  //           this.AccountType = res.data.map((accType: any) => {
  //             const matchedType = this.getAccount(accType);
  //             //  ;
  //             return {
  //               id: accType.Id,
  //               name: matchedType?.name || accType.Value,
  //               isActive: accType.IsActive,
  //               Bonus: accType.Bonus,
  //               bg_image: matchedType?.bg_image,
  //               kycStatus: accType.kycStatus,
  //             };
  //           });
  //           this.loadFirstPaymentMethod();
  //           console.log('Active Payment Methods:', this.AccountType);
  //         } else {
  //           this.AccountType = [];
  //           this.handleError.handleResponseError(res);
  //         }
  //         this.loaderService.hide();
  //       },
  //       (error) => {
  //         this.handleError.handleHttpError(error);
  //         this.loaderService.hide();
  //       }
  //     );
  // }
  getActivePaymentMethods(promoCode?: string) {
    const trimmedPromoCode = (promoCode || '').trim();
    const previouslySelectedType = this.selectedAccountType;

    if (trimmedPromoCode) {
      this.isApplyingPromo = true;
    } else {
      this.isLoadingPaymentMethods = true;
    }

    let apiurl = 'PaymentMethod/GetAllActivePaymentMethods';
    if (trimmedPromoCode) {
      apiurl += `?promocode=${encodeURIComponent(trimmedPromoCode)}`;
    }

    this.apiCallService
      .GetCallWithToken(apiurl)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res && res.responseCode == 200) {
            // 1. Map the data and then Filter immediately
            this.AccountType = res.data
              .map((accType: any) => {
                const matchedType = this.getAccount(accType);
                return {
                  id: accType.Id,
                  name: matchedType?.name || accType.Value,
                  isActive: accType.IsActive,
                  Bonus: accType.Bonus,
                  bg_image: matchedType?.bg_image,
                  kycStatus: accType.kycStatus,
                  MinDepositLimit: accType.MinDepositLimit,
                  MaxDepositLimit: accType.MaxDepositLimit,
                  isPromoAvailable: accType.IsPromoAvailable === true || accType.IsPromoAvailable === 1,
                };
              })
              // 2. Only keep items where isActive is true
              .filter((acc: any) => acc.isActive === true || acc.isActive === 1)
              // 3. Show the highest bonus first
              .sort((a: any, b: any) => (b.Bonus || 0) - (a.Bonus || 0));

            if (trimmedPromoCode) {
              const promoMessage = res.responseMessage || '';
              const isInvalidPromo = /invalid|inactive|expired|not\s*found|not\s*eligible|already\s*used/i.test(promoMessage);

              if (isInvalidPromo) {
                this.appliedPromoCode = '';
                this.promoError = promoMessage || 'Invalid or inactive promo code.';
                this.toastr.error(this.promoError, 'Promo Code');
              } else {
                this.appliedPromoCode = trimmedPromoCode;
                this.promoError = '';
                this.toastr.success(promoMessage || 'Promo code applied', 'Promo Code');
              }

              const stillSelected = this.AccountType.find(
                (acc: any) => acc.name === previouslySelectedType
              );
              if (stillSelected) {
                this.togglePayment(
                  stillSelected.name,
                  stillSelected.isActive,
                  stillSelected.kycStatus
                );
              } else {
                this.loadFirstPaymentMethod();
              }
            } else {
              this.loadFirstPaymentMethod();
            }
            // console.log('Filtered Active Payment Methods:', this.AccountType);
          } else {
            this.AccountType = [];
            this.handleError.handleResponseError(res);
          }
          this.isLoadingPaymentMethods = false;
          this.isApplyingPromo = false;
        },
        (error) => {
          this.handleError.handleHttpError(error);
          this.isLoadingPaymentMethods = false;
          this.isApplyingPromo = false;
        }
      );
  }

  // Promo code applied to the payment methods list — entering a code and
  // clicking Apply re-fetches PaymentMethod/GetAllActivePaymentMethods
  // with ?promocode= so the backend can return the promo-adjusted bonuses.
  promoCode: string = '';
  appliedPromoCode: string = '';
  isApplyingPromo: boolean = false;
  promoError: string = '';

  get selectedAccountPromoAvailable(): boolean {
    const acc = this.AccountType?.find(
      (a: any) => a.name === this.selectedAccountType
    );
    return !!acc?.isPromoAvailable;
  }

  applyPromoCode(): void {
    const code = (this.promoCode || '').trim();
    if (!code) {
      this.toastr.info('Please enter a promo code', 'Promo Code');
      return;
    }
    this.getActivePaymentMethods(code);
  }
  getAccount(acc: any) {
    const types = paymentTypes;
    const match = Object.values(types).find(
      (type: any) => type.ApiName.toLowerCase() === acc.Value.toLowerCase()
    );
    return match;
  }

  loadFirstPaymentMethod() {
    const FirstMethod = this.AccountType[0];
    this.selectedAccountType = FirstMethod.name;
    this.togglePayment(
      FirstMethod.name,
      FirstMethod.isActive,
      FirstMethod.kycStatus
    );
  }
  accountsTitle: any;
  accountTitleDropdownOpen = false;
  showPayPalFields: boolean = false;
  payPalDetails: any;
  CustomerTag: any = '';
  qrCodeImage: string = '';
  selectAccountTitle(accountDetail: any) {
    this.qrCodeImage = '';
    this.selectedAccounttitle = accountDetail.AccountTitle;
    this.accountTitleDropdownOpen = false;

    if (this.selectedAccountType == 'Paypal') {
      // debugger
      this.showPayPalFields = true;
      this.payPalDetails = accountDetail;
      this.qrCodeImage = accountDetail.ImageUrl;
    } else if (this.selectedAccountType == 'Chime') {
      this.CustomerTag = accountDetail.CustomerTag;
      this.qrCodeImage = accountDetail.ImageUrl;
      this.showPayPalFields = false;
      this.payPalDetails = null;
    } else if (this.selectedAccountType == 'Venmo') {
      this.CustomerTag = accountDetail.CustomerTag;
      this.qrCodeImage = accountDetail.ImageUrl;
      this.showPayPalFields = false;
      this.payPalDetails = null;
    } else if (this.selectedAccountType == 'Zelle') {
      this.CustomerTag = accountDetail.CustomerTag;
      this.qrCodeImage = accountDetail.ImageUrl;
      this.showPayPalFields = false;
      this.payPalDetails = null;
    } else {
      this.showPayPalFields = false;
      this.payPalDetails = null;
      this.qrCodeImage = accountDetail.ImageUrl;
    }
  }







  // uploadProfileImage: string = '';
  // async onFileSelected(event: Event) {
  //   const file = (event.target as HTMLInputElement)?.files?.[0];

  //   if (file) {
  //     try {
  //       //? Show loader while processing
  //       this.loaderService.show();

  //       //? Convert the file to a base64 string
  //       const base64Image = await this.convertFileToBase64(file);

  //       //? Create the API payload
  //       const payload: any = {
  //         base64Image: base64Image,
  //       };
  //       this.uploadProfileImage = base64Image;
  //       this.loaderService.hide();
  //     } catch {}
  //   }
  // }
  // private convertFileToBase64(file: File): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onload = () => resolve(reader.result as string);
  //     reader.onerror = (error) => reject(error);
  //     reader.readAsDataURL(file);
  //   });
  // }



  uploadProfileImage: string = '';

  async onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement)?.files?.[0];

    if (file) {
      try {
        this.loaderService.show();

        const base64Image = await this.convertFileToBase64(file);

        const payload: any = {
          base64Image: base64Image,
        };

        this.uploadProfileImage = base64Image;

        this.loaderService.hide();
      } catch (error) {
        this.loaderService.hide();
        console.error(error);
      }
    }
  }


  private convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const img = new Image();

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = img.width;
          canvas.height = img.height;

          ctx?.drawImage(img, 0, 0);

          const compressedBase64 = canvas.toDataURL('image/jpeg', 0.6);

          // LOGS HERE
          console.log(
            'Original Size:',
            (file.size / 1024).toFixed(2),
            'KB'
          );

          console.log(
            'Compressed Size:',
            ((compressedBase64.length * 3) / 4 / 1024).toFixed(2),
            'KB'
          );

          resolve(compressedBase64);
        };

        img.onerror = reject;
        img.src = e.target.result;
      };

      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  clearSelection() {
    this.uploadProfileImage = '';
  }
  hideWalletModal() {
    this.showModal = false;
    this.handleError.showModalSubject.next(false);
    // this.isShowManualEntry = false;
    this.uploadProfileImage = '';
    this.selectedAccount = '';
    this.selectedAccounttitle = '';
    this.promoCode = '';
    this.appliedPromoCode = '';
  }

  accountTypeDropdownOpen = false;
  sourceAccount: string = '';
  isAccountTypeSelected: boolean = false;

  selectAccountType(name: string, event: Event) {
    event.stopPropagation();
    this.sourceAccount = name;
    this.accountTypeDropdownOpen = false;
    this.onAccountTypeChange({ target: { value: name } } as any);
  }

  onAccountTypeChange(event: Event) {
    this.isAccountTypeSelected = true;
    this.sourceAccount = (event.target as HTMLSelectElement).value;
  }
  accountTypeData: any = [
    {
      id: 1,
      name: 'CashApp',
    },
    {
      id: 2,
      name: 'Chime',
    },
    {
      id: 3,
      name: 'Zelle',
    },
    // {
    //   id: 4,
    //   name: 'Transic (payment link)',
    // },
  ];

  amouttowithdraw: number = 0;
  accountInfo: string = '';

  // Authorize.Net Payment Integration Start
  payCard() {
    this.loaderService.show();
    if (this.paymentForm.invalid) {
      this.paymentForm.markAllAsTouched();
      this.loaderService.hide();
      return;
    }
    const apiurl = `CashAppPayment/GetAuthorizeAccountInfo?Amount=${this.paymentForm.value.amount}&Source=Square`;
    this.apiCallService.GetCallWithToken(apiurl).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (response && response.responseCode === 200) {
          this.loaderService.hide();
          this.pay(
            response.data.clientKey,
            response.data.apiLoginID,
            response.data.id
          );
        } else {
          this.handleError.handleResponseError(response);
          this.loaderService.hide();
        }
      },
      error: (error) => {
        this.handleError.handleHttpError(error);
        this.loaderService.hide();
      },
    });
  }
  async pay(clientKey?: string, apiLoginID?: string, accountid?: number) {
    this.loaderService.show();
    // if (this.paymentForm.invalid) {
    //   this.paymentForm.markAllAsTouched();
    //   this.loaderService.hide();
    //   return;
    // }

    try {
      const formValue = this.paymentForm.value;
      const cardData = {
        cardNumber: formValue.cardNumber.toString(),
        month: formValue.month.toString(),
        year: formValue.year.toString().slice(-2),
        cardCode: formValue.cvv.toString(),
      };
      // These come from Authorize.Net merchant account (client key + login ID)
      // const authData = {
      //   clientKey: '8CRkkTs9N2M69SY6p6XMen7mk5xKP4khDmVwu2jTun93F3rK7VTqyq3kGZybTBC9',
      //   apiLoginID: '2aUJ4fF7U'
      // };
      const authData = {
        clientKey: clientKey,
        apiLoginID: apiLoginID,
      };

      const opaqueData = await this.getPaymentNonce(
        cardData,
        authData,
        accountid
      );
      // console.log('Opaque Data Genrated:', opaqueData);
    } catch (err) {
      console.error('Error generating token:', err);
      this.loaderService.hide();
    }
  }

  opaquePayload: any;
  getPaymentNonce(cardData: any, authData: any, accountid: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!(window as any).Accept) {
        console.error('Authorize.Net Accept.js library not loaded.');
        this.loaderService.hide();
        return;
      }
      (window as any).Accept.dispatchData(
        {
          authData,
          cardData,
        },
        (response: any) => {
          if (response.messages.resultCode === 'Error') {
            reject(response.messages.message[0].text);
            this.loaderService.hide();
          } else {
            resolve(response.opaqueData);
            // this.opaquePayload = { opaqueData: response.opaqueData };
            this.opaquePayload = {
              customerId: Number(localStorage.getItem('customerId')),
              amount: this.paymentForm.value.amount,
              source: 'Square',
              accountId: accountid,
              opaqueData: {
                dataDescriptor: response.opaqueData.dataDescriptor,
                dataValue: response.opaqueData.dataValue,
              },
            };

            // console.log('Payment nonce (opaqueData):', this.opaquePayload);
            this.sendDatatoApi();
          }
        }
      );
    });
  }

  sendDatatoApi() {
    this.apiCallService
      .PostCallWithToken(
        this.opaquePayload,
        'CashAppPayment/AuthorizeCardPaymentProcessor'
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            this.toastr.success(response.responseMessage, 'Success');
            this.paymentForm.reset();
            this.loaderService?.triggerWalletFunction();
            this.loaderService.hide();
          } else {
            this.handleError.handleResponseError(response);
            this.loaderService.hide();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.loaderService.hide();
        },
      });
  }
  // Authorize.Net Payment Integration End

  // Stripe Cash App Payment Integration Start
  getCustomerId(): string | null {
    return localStorage.getItem('customerId');
  }
  paycashApp() {
    this.loaderService.show();

    if (this.cashappForm.invalid) {
      this.cashappForm.markAllAsTouched();
      this.loaderService.hide();
      return;
    }
    // Open a new blank tab immediately to prevent browser pop-up blockers
    const newTab = window.open('', '_blank');
    // const amount = this.cashappForm.get('amount')?.value;
    const amount = this.cashappForm.get('amount')?.value * 100;
    const customerId = this.getCustomerId();
    const promocode = this.appliedPromoCode || '';
    const posturl = `PaymentIntent/CreatePaymentIntent?amount=${amount}&CustomerId=${customerId}&Source=stripe,cashapp&promocode=${encodeURIComponent(promocode)}`;

    this.apiCallService.PostCallWithToken(null, posturl).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (response && response.responseCode === 200) {
          this.toastr.success(response.responseMessage, 'Success');
          if (newTab) {
            newTab.location.href = response.data.mobile_auth_url; // Redirect the blank tab
          } else {
            window.open(response.data.mobile_auth_url, '_blank'); // Fallback in case tab is blocked
          }
        } else {
          this.handleError.handleResponseError(response);
          if (newTab) newTab.close(); // Close the tab if API fails
        }
        this.loaderService.hide();
        this.hideWalletModal();
      },
      error: (error) => {
        this.handleError.handleHttpError(error);
        if (newTab) newTab.close(); // Close the tab on error
        this.loaderService.hide();
        this.hideWalletModal();
      },
    });
  }
  // Stripe cash app integration end

  // KYC for NotSubmited Popup Texts

  popupTitle = '';
  popupMessage = '';
  popupButtonText = '';
  popupRedirect: string | null = null;

  Ntitlekyc: string = 'KYC Required';
  Nmessagekyc: string = 'Please complete KYC Form for Payments.';
  Nbuttontextkyc: string = 'KYC Form';
  NredirecttoKYCform: string = '/dashboard/KYCform';
  // KYC for pending Popup Texts
  ptitlekyc: string = 'KYC Verification';
  pmessagekyc: string =
    'Your verification is currently in process. Please wait while we complete the review.';
  pbuttontextkyc: string = 'Got it';

  // toogles payment buttons
  showSquare: boolean = false;
  togglePayment(
    name: string,
    active?: boolean,
    kycCompleted?: boolean,
    event?: Event
  ) {
    if (kycCompleted === true) {
      const kyc = localStorage.getItem('KYC');
      if (kyc === 'Pending') {
        this.popupTitle = this.ptitlekyc;
        this.popupMessage = this.pmessagekyc;
        this.popupButtonText = this.pbuttontextkyc;
        this.popupRedirect = null;
        this.showKycPopup = true;

        return;
      } else if (kyc === 'Not Submitted') {
        this.popupTitle = this.Ntitlekyc;
        this.popupMessage = this.Nmessagekyc;
        this.popupButtonText = this.Nbuttontextkyc;
        this.popupRedirect = this.NredirecttoKYCform;
        this.showKycPopup = true;

        return;
      }
    }
    if (active === false) {
      return;
    } else {

      // --- Fetching Min ANd Max ---
      const selectedMethod = this.AccountType.find((acc: any) => acc.name === name);

      if (selectedMethod) {
        this.minDeposit = selectedMethod.MinDepositLimit ?? 0;
        this.maxDeposit = selectedMethod.MaxDepositLimit ?? 0;
        // console.log(`Limits Loaded for ${name}: Min = ${this.minDeposit}, Max = ${this.maxDeposit}`);
      } else {
        this.minDeposit = 0;
        this.maxDeposit = 0;
      }
      // ----------------------------------------------


      this.qrCodeImage = '';
      this.selectedAccountType = name;
      if (event) {
        event.preventDefault();
      }
      if (name == 'Card') {
        this.showcardForm();
      } else if (name == 'CashApp') {
        this.showcashAppForm();
        this.cashAppPayInitialized = false;
        try {
          if (this.cashAppPay && typeof this.cashAppPay.destroy === 'function')
            this.cashAppPay.destroy();
        } catch (e) {
          /* ignore */
        }
      } else if (name == 'Chime') {
        this.showChimeZelleForm();
        this.selectedAccount = 'Chime';
        // this.accountsTitle = this.ChimeAccounts;
        this.loadDropDownValues();
      } else if (name == 'Zelle') {
        this.showChimeZelleForm();
        this.selectedAccount = 'Zelle';
        // this.accountsTitle = this.ZelleAccounts;
        this.loadDropDownValues();
      } else if (name == 'Paypal') {
        this.showChimeZelleForm();
        this.selectedAccount = 'Paypal';
        this.loadDropDownValues();
      } else if (name == 'Venmo') {
        this.showChimeZelleForm();
        this.selectedAccount = 'Venmo';
        this.loadDropDownValues();
      }
      else if (name == 'GooglePay') {
        // this.showChimeZelleForm();
        this.newBalance = 0;
        this.email = ''
        this.showChimeZelle = false;
        this.showcashApp = false;
        this.showcard = false
        this.selectedAccount = 'GooglePay';
        this.loadDropDownValues();
      }
      else if (name == 'ApplePay') {
        // this.showChimeZelleForm();
        this.newBalance = 0;
        this.email = ''
        this.showChimeZelle = false;
        this.showcashApp = false;
        this.showcard = false;
        this.selectedAccount = 'ApplePay';
        this.loadDropDownValues();
      }
      else if (name == 'Card2') {
        this.showChimeZelleForm();
        this.newBalance = 0;
        this.email = ''
        // this.showChimeZelle=false;
        // this.showcashApp=false;
        // this.showcard=false
        this.selectedAccount = 'Card2';
        this.loadDropDownValues();
      }
      else if (name == 'CashApp2') {
        // this.showChimeZelleForm();
        this.newBalance = 0;
        this.email = ''
        this.showChimeZelle = false;
        this.showcashApp = false;
        this.showcard = false
        this.selectedAccount = 'CashApp2';
        this.cashAppPayInitialized = false;
        try {
          if (this.cashAppPay && typeof this.cashAppPay.destroy === 'function')
            this.cashAppPay.destroy();
        } catch (e) {
          /* ignore */
        }
        this.loadDropDownValues();
      }
      else {
        return;
      }
    }
  }

  showcard: boolean = false;
  showcardForm() {
    this.showSquare = true;
    this.showcard = true;
    this.showcashApp = false;
    this.showChimeZelle = false;
    this.stripeCardUi = false;
    this.StripeCardAccountID = '';
    this.StripeCardPublishKey = '';
    this.StripeCardSecret = '';
  }
  showcashApp: boolean = false;
  showcashAppForm() {
    this.showcashApp = true;
    this.showcard = false;
    this.showChimeZelle = false;
  }
  showChimeZelle: boolean = false;
  showChimeZelleForm() {
    this.newBalance = 0;
    this.selectedAccounttitle = '';
    this.showChimeZelle = true;
    this.showcashApp = false;
    this.showcard = false;
  }

  // Local loading flag for the Account Title/Amount dropdown data — this
  // used to fire the full-screen loaderService spinner every time a
  // payment method is selected (including the auto-selected first one
  // right after the popup opens), which is what showed up as a spinner
  // flash between the payment-methods skeleton and the popup settling.
  isLoadingDropdownValues = false;
  loadDropDownValues() {
    this.accountsTitle = [];
    const paylaod = {
      paymentName: this.selectedAccountType,
    };
    this.isLoadingDropdownValues = true;
    this.apiCallService
      .PostCallWithToken(paylaod, 'PaymentMethod/GetManuallPaymentsAccountInfo')
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res && res.responseCode == 200) {
            this.isLoadingDropdownValues = false;
            if (this.selectedAccountType == 'Paypal') {
              this.accountsTitle = res.data.map((acc: any) => ({
                id: acc.id,
                Value: acc.Value,
                Email: acc.Email,
                AccountTitle: acc.AccTitle,
                Link: acc.Link,
                Bonus: acc.Bonus,
                ImageUrl: acc.ImageUrl,
              }));
            } else {
              this.accountsTitle = res.data;
            }
          } else {
            this.handleError.handleResponseError(res);
          }
          this.isLoadingDropdownValues = false;
        },
        (error) => {
          this.handleError.handleHttpError(error);
          this.isLoadingDropdownValues = false;
        }
      );
  }

  isCopied = signal(false);
  CopyToClipBoard(text: string) {
    if (text != '') {
      navigator.clipboard.writeText(text);
      this.isCopied.set(true);
      setTimeout(() => {
        this.isCopied.set(false);
      }, 2000);
    }
  }

  RedirectToLink(link: string) {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
    window.open(link, '_blank');
  }



  // Post call to Square Payment API

  //   {
  //   "customerId": 0,
  //   "amount": 0,
  //   "source": "string",
  //   "accountId": 0,
  //   "cardSourceId": "string"
  // }

  // Whop payment integration start

  whopPayment(token: string) {
    this.squareForm.markAllAsTouched();
    if (this.squareForm.invalid) {
      this.isProcessingPayment = false;
      return;
    }
    this.isProcessingPayment = true;
    const payload = {
      payment: this.squareForm.value.amount?.toString(),
      source: token,
    };
    this.apiCallService
      .PostCallWithToken(payload, 'whop/webhook/CreateWhopPayment')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            const newTab = window.open('', '_blank');
            this.toastr.success(response.responseMessage, 'Success');
            this.squareForm.reset();
            this.isProcessingPayment = false;
            if (newTab) {
              newTab.location.href = response.data?.purchaseURL; // Redirect the blank tab
            } else {
              window.open(response.data?.purchaseURL, '_blank'); // Fallback in case tab is blocked
            }
            this.hideWalletModal();
          } else {
            this.handleError.handleResponseError(response);
            this.isProcessingPayment = false;
            this.hideWalletModal();
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.isProcessingPayment = false;
          this.hideWalletModal();
        },
      });
  }

  // whop payment integration end


  // Stripe Card Payment Integration Start
  stripeCardUi: boolean = false;
  StripeCardAccountID: any
  StripeCardPublishKey: any
  StripeCardSecret: any
  StripeCardPaymentIntentId: any

  createStripeCardPayment() {

    this.squareForm.markAllAsTouched();
    if (this.squareForm.invalid) {
      return;
    }
    this.isProcessingPayment = true;
    const formValue = this.squareForm.value;
    const payload = {
      customerId: Number(localStorage.getItem('customerId')),
      amount: formValue.amount,
      source: 'stripe,card',
      accountId: 0,
      cardSourceId: '',
      email: formValue.email,
      addressLine1: formValue.addressLine1,
      addressLine2: formValue.addressLine2,
      city: formValue.city,
      zip: Number(formValue.zip),
      state: formValue.state,
      postalCode: formValue.postalCode,
      country: formValue.country,
      billerName: formValue.billerName,
      promocode: this.appliedPromoCode || ''
    }
    this.apiCallService
      .PostCallWithToken(
        payload,
        'PaymentIntent/CreateStripeCardPayment'
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            this.toastr.success(response.responseMessage, 'Success');
            // this.paymentForm.reset();
            this.StripeCardAccountID = response?.data?.accountid;
            this.StripeCardPublishKey = response?.data?.publishKey;
            this.StripeCardSecret = response?.data?.clientSecret;
            this.StripeCardPaymentIntentId = response?.data?.paymentIntentId;
            this.stripeCardUi = true;
            this.loadCardUiStripe();
            this.isProcessingPayment = false;
          } else {
            this.handleError.handleResponseError(response);
            this.isProcessingPayment = false;
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.isProcessingPayment = false;
        },
      });
  }

  async loadCardUiStripe() {
    this.stripe = await loadStripe(this.StripeCardPublishKey);
    // Check if stripe initialized successfully
    if (this.stripe) {
      this.elements = this.stripe.elements();
      // Create and mount the card
      this.card = this.elements.create('card');
      this.card.mount('#card-element');
      this.loaderService.hide();
    } else {
      console.error('Stripe failed to load');
      this.loaderService.hide();
    }
  }


  async stripeCardAuthenticate() {
    this.isProcessingPayment = true;
    const clientSecret = this.StripeCardSecret.toString();

    const result = await this.stripe!.confirmCardPayment(clientSecret, {
      payment_method: {
        card: this.card
      }
    });

    if (result.error) {
      this.toastr.warning(result.error.message, 'Warning');
      this.isProcessingPayment = false;
    } else if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
      // alert("Payment Successful!");
      this.verifyStripeCardPayment();
    }
  }

  verifyStripeCardPayment() {
    this.isProcessingPayment = true;
    this.apiCallService
      .PostCallWithToken(null, `PaymentIntent/VerifyStripeCardPayment?accountid=${this.StripeCardAccountID}&intentid=${this.StripeCardPaymentIntentId}`).pipe(takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            this.toastr.success(response.responseMessage, 'Success');
            this.loaderService?.triggerWalletFunction();
            this.showcardForm();
            this.hideWalletModal();
            this.isProcessingPayment = false;
          } else {
            this.handleError.handleResponseError(response);
            this.isProcessingPayment = false;
          }
        },
        error: (error) => {
          this.handleError.handleHttpError(error);
          this.isProcessingPayment = false;
        },
      });

  }

  // Stripe Card Payment Integration End

  showQrPopup = false;

  openQrPopup(): void {
    this.showQrPopup = true;
  }

  closeQrPopup(): void {
    this.showQrPopup = false;
  }


  createTapTapPayload() {
    const localEmail = localStorage.getItem('email') || '';
    const localCustomerId = parseInt(localStorage.getItem('customerId') || '0', 10);

    // Logic for Source
    const source = this.selectedAccountType === 'CashApp2'
      ? 'TapTap,CashApp'
      : this.selectedAccountType;

    // Logic for Payment Provider
    let paymentProvider = "";
    const typeLower = this.selectedAccountType?.toLowerCase();

    if (typeLower === 'googlepay' || typeLower === 'applepay') {
      paymentProvider = typeLower;
    }

    return {
      amount: this.newBalance,
      source: source,
      paymentProvider: paymentProvider,
      email: localEmail,
      customerId: localCustomerId,
      promocode: this.appliedPromoCode || ''
    };
  }



  AddTapTapCashApp() {
    this.isProcessingPayment = true;
    const selectedAccountDetails = this.AccountType.find(
      (account: any) => account.name === this.selectedAccount
    );

    if (selectedAccountDetails) {
      const amount = this.newBalance || 0;
      const min = selectedAccountDetails.MinDepositLimit;
      const max = selectedAccountDetails.MaxDepositLimit;

      // 2. Perform the limit checks
      if (amount < min) {
        this.toastr.warning(`Error: Min Deposit for ${this.selectedAccount} is ${min}`, 'Invalid Amount');
        this.isProcessingPayment = false;
        return
      }

      if (max > 0 && amount > max) {
        this.toastr.warning(`Error: Max Deposit for ${this.selectedAccount} is ${max}`, 'Invalid Amount');
        this.isProcessingPayment = false;
        return
      }
    }
    const payload = this.createTapTapPayload();
    // Open a new blank tab immediately to prevent browser pop-up blockers
    const newTab = window.open('', '_blank');
    this.apiCallService.PostCallWithToken(payload, 'TapTapup/CreateTapTapPayment').pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (response && response.responseCode === 200) {
          this.toastr.success(response.responseMessage, 'Success');
          if (newTab) {
            newTab.location.href = response.data.redirect_url; // Redirect the blank tab
          } else {
            window.open(response.data.redirect_url, '_blank'); // Fallback in case tab is blocked
          }
        } else {
          this.handleError.handleResponseError(response);
          if (newTab) newTab.close(); // Close the tab if API fails
        }
        this.isProcessingPayment = false;
      },
      error: (error) => {
        this.handleError.handleHttpError(error);
        if (newTab) newTab.close(); // Close the tab on error
        this.isProcessingPayment = false;
      },
    });
  }






  AddAppleGooglePayPayload() {
    return {
      customerId: this.getCustomerID(),
      balance: this.newBalance || 0,
      email: this.email || '',
      type: 'Credit',
      status: 'Pending',
      source: this.selectedAccount || '',
      accountTitle: '',
      imageUrl: this.uploadProfileImage || '',
      accountInfo: '',
      promocode: this.appliedPromoCode || ''
    };
  }



  AddAppleGoogleCashApp2Pay() {
    const payload = this.AddAppleGooglePayPayload();
    //  if (!payload.balance || payload.balance < 5 || payload.balance > 300) {
    //   this.toastr.info('Amount must be within 5 to 300', 'Invalid Amount');
    //     return; 
    // }
    // 1. Find the selected account details from the AccountType list
    const selectedAccountDetails = this.AccountType.find(
      (account: any) => account.name === this.selectedAccount
    );

    if (selectedAccountDetails) {
      const amount = this.newBalance || 0;
      const min = selectedAccountDetails.MinDepositLimit;
      const max = selectedAccountDetails.MaxDepositLimit;

      // 2. Perform the limit checks
      if (amount < min) {
        this.toastr.warning(`Error: Min Deposit for ${this.selectedAccount} is ${min}`, 'Invalid Amount');
        this.isProcessingPayment = false;
        return
      }

      if (max > 0 && amount > max) {
        this.toastr.warning(`Error: Max Deposit for ${this.selectedAccount} is ${max}`, 'Invalid Amount');
        this.isProcessingPayment = false;
        return
      }
    }

    if (payload.source === 'CashApp2') {
      payload.source = 'TapTap,CashApp';
    }
    if (payload.source === 'Card2') {
      payload.source = 'CashTap';
    }

    if (
      payload.imageUrl != '' &&
      payload.source != '' &&
      payload.email != ''
    ) {
      this.isProcessingPayment = true;
      this.apiCallService
        .PostCallWithToken(payload, 'Wallet/CreateWalletPaymentRequest')
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            if (response && response.responseCode === 200) {
              this.toastr.success(response.responseMessage, 'Success');
              this.loaderService?.triggerWalletFunction();
              this.isProcessingPayment = false;
              this.hideWalletModal();
            } else {
              this.handleError.handleResponseError(response);
              // this.loaderService.hide();
              this.hideWalletModal();
            }
          },
          error: (error) => {
            this.handleError.handleHttpError(error);
            // this.loaderService.hide();
            this.hideWalletModal();
          },
        });
    } else {
      this.toastr.info(
        'Please Enter Amount, Email and Upload image',
        'Validation'
      );
    }
  }




// cashAppAmounts: number[] = [
//   5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 25, 30, 31, 40, 50, 60, 100, 125, 130, 150, 200, 300, 400, 500
// ];
cashAppAmounts: number[] = [
  5,10, 15, 18, 20, 25, 30, 31, 40, 50, 60, 100, 125, 130, 150, 200, 300, 400, 500
];

// googleApplePayAmounts: number[] = [
// 4.99, 5.99, 6.99, 7.99, 8.99, 9.99, 10.99, 11.99, 12.99, 13.99, 14.99, 15.99, 17.99, 19.99, 21.99, 24.99, 29.99, 30.99, 34.99, 39.99, 41.99, 49.99, 54.99, 59.99, 69.99, 79.99, 99.99
// ];

// googleApplePayAmounts: number[] = [
//   5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 22, 25, 30, 31, 35, 40, 42, 50, 55, 60, 70, 80, 100
// ];

googleApplePayAmounts: number[] = [
  5, 10, 15, 18, 20, 25, 30, 31, 40, 50, 60, 100, 125, 130, 150, 200, 300, 400, 500
];

  // PaymentMethodName values to look up in the PaymentValues table. Update these if the
  // rows are added under different names.
  private readonly CASH_APP_PAYMENT_METHOD_NAME = 'CashApp';
  private readonly GOOGLE_APPLE_PAY_PAYMENT_METHOD_NAME = 'GooglePay';

  // Pulls cashAppAmounts / googleApplePayAmounts from the backend, falling back to the
  // hardcoded defaults above whenever the API isn't reachable yet or returns nothing usable.
  private loadDynamicPaymentAmounts() {
    this.fetchPaymentAmounts(this.CASH_APP_PAYMENT_METHOD_NAME, (amounts) => {
      this.cashAppAmounts = amounts;
    });
    this.fetchPaymentAmounts(this.GOOGLE_APPLE_PAY_PAYMENT_METHOD_NAME, (amounts) => {
      this.googleApplePayAmounts = amounts;
    });
  }

  private fetchPaymentAmounts(
    paymentMethodName: string,
    applyAmounts: (amounts: number[]) => void,
  ) {
    this.apiCallService
      .GetCallWithToken(
        `PaymentValues/GetPaymentValueByMethodName?paymentMethodName=${encodeURIComponent(paymentMethodName)}`,
      )
      .subscribe({
        next: (response: any) => {
          const rows = response?.responseCode === 200 ? response.data : [];
          const amounts = (Array.isArray(rows) ? rows : [])
            .map((row: any) => Number(row?.values ?? row?.Values))
            .filter((amount: number) => !isNaN(amount) && amount > 0);

          // Empty / all-zero / not-found result -> keep the hardcoded defaults.
          if (amounts.length) {
            applyAmounts(amounts);
          }
        },
        // API not deployed yet or errored -> keep the hardcoded defaults.
        error: () => {},
      });
  }

  goToLevelScreen() {
    this.router.navigate(['dashboard/player-level']);
    this.showModal = false;
    this.handleError.showModalSubject.next(false);
  }

  trackByIndex(index: number): number {
    return index;
  }
}
